import { createContext, Context } from 'react';
import { Edge, Node } from 'reactflow';
import { NodeItem } from './index';

export interface IEditorContext {
  addNode: (node: NodeItem, from?: string, checkExisting?: boolean) => void;
  showAddModal: (type: string, source: string) => void;
  openPanel: (nodeId: string) => void;
  updateData: (data: any, openedAsset?: boolean) => void;
  onBtnClick: (node: string, type: any) => void;
  editable?: boolean;
  removeNode: (nodeId: string) => void;
  scanAssets: (cidr: string) => void;
  scanTags: (gateway_id: string, service: any) => void;
  stopScan: (gateway_id: string, commandId: any) => void;
  duplicateNode: (node: Node, connectedEdges: Edge[]) => void;
  scanning: number[];
  useCase?: boolean;
  scanningTags: string[];
  setScanningTags: any;
  assetCompsData: any;
  scanFailed?: boolean;
  disableScanStop: any;
  hasAccessTo: any;
  scanningGateways: string[];
  isLiveView?: boolean;
  activeNode: any;
  activeComponentId?: number | null;
  onGatewayImportClick: (gatewayId: string, gatewayData: any) => void;
}

export interface ITelemetryContext {
  telemetry: any;
  connections: any;
}

export const TelemetryContext: Context<ITelemetryContext> = createContext<ITelemetryContext>({
  telemetry: {},
  connections: {},
});

export const EditorContext: Context<IEditorContext> = createContext({
  addNode: (node: NodeItem, from?: string, checkExisting?: boolean) => {},
  showAddModal: (type: string, source: string) => {},
  openPanel: (nodeId) => {},
  updateData: (data, openedAsset) => {},
  onBtnClick: (node, type) => {},
  removeNode: (nodeId: string) => {},
  scanAssets: (cidr: string) => {},
  scanTags: (gateway_id: string, service: any) => {},
  stopScan: (gateway_id: string, commandId: any) => {},
  duplicateNode: (node: Node, connectedEdges: Edge[]) => {},
  scanning: [] as number[],
  scanningTags: [] as string[],
  setScanningTags: {},
  assetCompsData: {},
  disableScanStop: {},
  hasAccessTo: {},
  scanningGateways: [] as string[],
  activeNode: {},
  onGatewayImportClick: (gatewayId: string, gatewayData: any) => {},
});
